import React, { useEffect, useState } from 'react'
import Main from '../../cpn/Main'
import { DatePicker, Flex, Form, Space, Table, Button } from 'antd';
import { useShangpindingdanListQuery,} from '../../store/dianshangtaizhangApi';
import GoodsOrderEdit from './GoodsOrderEdit';
import dayjs from 'dayjs'
import FirmSelect from '../firm/FirmSelect';
import GoodsSelect from '../goods/GoodsSelect';
import GoodsOrderDel from './GoodsOrderDel';
import GoodsOrderAdd from './GoodsOrderAdd';
const {RangePicker} = DatePicker;
function GoodsOrderQuery() {
    const [form] = Form.useForm();
    const [list, setList] = useState();    
    const [query,setQuery] = useState({spdd_hyt_id:localStorage.getItem('GoodsOrderQuery_spdd_hyt_id') || ''});
    const {data, isSuccess} = useShangpindingdanListQuery(query, {refetchOnMountOrArgChange: true})
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {spdd_id:key,spdd_yonghushu,spdd_jieshu_date,spdd_qy_name,spdd_gly_name,spdd_gly_phone,spdd_spgg_price,spdd_spgg_name,spdd_content,spdd_sp_name,spdd_jiaofei_date,spdd_spgg_day,spdd_uname,spdd_ctime,spdd_state} = item;                 
                    return item = {key,spdd_yonghushu,spdd_jieshu_date,spdd_qy_name,spdd_gly_name,spdd_gly_phone,spdd_spgg_price,spdd_spgg_name,spdd_content,spdd_sp_name,spdd_jiaofei_date,spdd_spgg_day,spdd_uname,spdd_ctime,spdd_state}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.spdd_ctime;
                    let bTimeString = b.spdd_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'spdd_qy_name',
            title: '企业',            
            dataIndex: 'spdd_qy_name',
        },  
        {
            key: 'spdd_sp_name',
            title: '商品',            
            dataIndex: 'spdd_sp_name',
        },
        {
            key: 'spdd_spgg_name',
            title: '规格',            
            dataIndex: 'spdd_spgg_name',
        },
        {
            key: 'spdd_jiaofei_date',
            title: '缴费日期',            
            dataIndex: 'spdd_jiaofei_date',
        },
        {
            key: 'spdd_jieshu_date',
            title: '结束日期',            
            dataIndex: 'spdd_jieshu_date',
        },
        {
            key: 'spdd_spgg_day',
            title: '剩余天数',            
            dataIndex: 'spdd_spgg_day',
            render:(_,record) => {
                const startDate = dayjs();
                const endDate = dayjs(record.spdd_jieshu_date);
                // 1. 计算年差
                const years = endDate.diff(startDate, 'year'); // 1 年
                const afterYears = startDate.add(years, 'year');
                // 2. 计算剩余月差
                const months = endDate.diff(afterYears, 'month'); // 0 个月
                const afterMonths = afterYears.add(months, 'month');
                // 3. 计算剩余天差
                const days = endDate.diff(afterMonths, 'day'); // 0 天
                return `${years}年${months}月${days}天`
            }
        },    
        {
            key: 'spdd_yonghushu',
            title: '用户',            
            dataIndex: 'spdd_yonghushu',
        },
        {
            key: 'spdd_spgg_price',
            title: '价格',            
            dataIndex: 'spdd_spgg_price',
        },           
          
        {
            key: 'spdd_gly_name',
            title: '管理员',            
            dataIndex: 'spdd_gly_name',
            render:(_,record) => {
                return record.spdd_gly_name + record.spdd_gly_phone
            }
        },      
        {
            key: 'spdd_content',
            title: '备注',            
            dataIndex: 'spdd_content',
        },              
        {
            key: 'spdd_state',
            title: '状态',            
            dataIndex: 'spdd_state',
        },              
      
        {
            key: 'spdd_ctime',
            title: '操作时间',            
            dataIndex: 'spdd_ctime',
            render: (_, record) => {
                return <Space>{record.spdd_uname} {record.spdd_ctime}</Space>
            }
        },    
      
        {
            key: 'key',
            title: '编号',            
            dataIndex: 'key',
        },    
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <GoodsOrderEdit spdd_id={record.key}/>
                        <GoodsOrderDel spdd_id={record.key}/>
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/GoodsOrderQuery']}>            
            <Flex gap={10} justify='space-between'>                
                <Form 
                    form={form}
                    layout="inline"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 6 }}
                >
                    <FirmSelect
                        placeholder='请选择企业'
                        style={{width:"200px"}}
                        onChange={(e,f) => {
                            setQuery(prevState=>({...prevState,spdd_qy_id:e}))
                            localStorage.setItem('GoodsOrderQuery_spdd_qy_id',e)
                        }}
                        formStyle={{marginBottom:"0px"}}
                        name='spdd_qy_id'
                    />
                    <GoodsSelect
                        placeholder='请选择商品'
                        style={{width:"200px"}}
                        formStyle={{marginBottom:"0px"}}
                        onChange={(e,f) => {
                            setQuery(prevState=>({...prevState,spdd_sp_id:e}))
                            localStorage.setItem('GoodsOrderQuery_spdd_sp_id',e)
                        }}
                        name='spdd_sp_id'
                    />
                    <Form.Item 
                        label='到期日期'
                        style={{marginBottom:"0px"}}
                        name='s_date'

                    >
                        <RangePicker
                            onChange={(e) => {
                                setQuery(prevState=>({...prevState,s_date:dayjs(e[0]).format('YYYY-MM-DD'),e_date:dayjs(e[1]).format('YYYY-MM-DD')})) 
                            }}
                            style={{width:"300px"}}                        
                        />
                    </Form.Item>
                    <Form.Item wrapperCol={{offset:3}} >
                        <Space>
                            <Button  htmlType='submit'>查询</Button>
                            <Button  
                                htmlType='reset' 
                                onClick={() => {
                                    form.resetFields();
                                    setQuery(prevState=>({...prevState,spdd_qy_id:'',spdd_sp_id:'',s_date:''}))
                                    localStorage.setItem('GoodsOrderQuery_spdd_qy_id','')
                                    localStorage.setItem('GoodsOrderQuery_spdd_sp_id','')
                                    localStorage.setItem('GoodsOrderQuery_s_date','')
                                    localStorage.setItem('GoodsOrderQuery_e_date','')
                                }}
                            >重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
                <GoodsOrderAdd />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
            />
        </Main>
    )
}

export default GoodsOrderQuery